import {NgModule} from '@angular/core';
import {MatInputModule} from '@angular/material/input';
import {CpeAutofocusDirective} from './cpe-autofocus.directive';
import {AutocompleteOffDirective} from './autocomplete-off.directive';

@NgModule({
    declarations: [
        CpeAutofocusDirective,
        AutocompleteOffDirective
    ],
    imports: [
        MatInputModule
    ],
    exports: [
        CpeAutofocusDirective,
        AutocompleteOffDirective
    ]
})
export class DirectivesModule {
}
